import { GroupBase, OptionProps, components } from "react-select";
import { JSX } from "react";
import { ReactSelectItem } from "/Helpers/ReactSelectItem";

const SearchGlobalFieldOption = (
  props: OptionProps<ReactSelectItem, false, GroupBase<ReactSelectItem>>,
): JSX.Element => {
  const { data, children, selectProps } = props;
  const inputValue = selectProps.inputValue.toLowerCase();
  const label = data.label;

  // Find the part of the label that matches the input value
  const startIndex = label.toLowerCase().indexOf(inputValue);
  const endIndex = startIndex + inputValue.length;

  return (
    <components.Option {...props}>
      {startIndex !== -1 ? (
        <>
          {label.substring(0, startIndex)}
          <strong>{label.substring(startIndex, endIndex)}</strong>
          {label.substring(endIndex)}
        </>
      ) : (
        children
      )}
    </components.Option>
  );
};

export default SearchGlobalFieldOption;
